const auth = {
    isLogged: () => window.location.search.includes("Session_Key")
};

export default auth;